// extracted by mini-css-extract-plugin
export var active = "_bf-7";
export var container = "_bf-0";
export var evenWidth = "_bf-4";
export var large = "_bf-5";
export var outlet = "_bf-8";
export var slide = "_bf-2";
export var small = "_bf-6";
export var tab = "_bf-3";
export var tabs = "_bf-1";